export enum SessionEventType {
  START = 'START',
  END = 'END',
  HEARTBEAT = 'HEARTBEAT',
  PAGE_VIEW = 'PAGE_VIEW',
}

export interface SessionEvent {
  type: SessionEventType;
  sessionId: string;
  timestamp: string;
  payload?: {
    metadata?: SessionMetadataInput;
    timeline?: SessionTimelineEventInput[];
    lastSeenAt?: string;
    pageViewDelta?: number;
    reason?: 'explicit' | 'timeout' | 'beforeunload';
  };
}

export interface SessionMetadataInput {
  userAgent: string;
  language: string;
  timezoneOffset: number;
}

export interface SessionTimelineEventInput {
  eventType: 'navigation' | 'user_action' | 'api_call' | 'console';
  data?: Record<string, unknown>;
  occurredAt: string;
}
